import { createSlice } from "@reduxjs/toolkit";
import { ticketModel } from "src/services/models/TicketModel";

const initialState = {
  data: {
    ...ticketModel,
  },
};

const ticketSlice = createSlice({
  name: "ticket_encoding",
  initialState,
  reducers: {
    storeTicket: (state, { payload }) => {
      state.data = payload;
    },
    getTicket: (state) => {
      state.data = { ...initialState.data };
    },
    clearTicket: (state) => {
      state.data = { ...ticketModel };
    },
  },
});

export const { storeTicket, getTicket, clearTicket } = ticketSlice.actions;
export default ticketSlice.reducer;
